import { FETCH_JOKL_COUPONS, CLEAN_JOKL_COUPONS, SET_JOKL_COUPON_PROCESSED, DELETE_JOKL_COUPON } from '../actions/types';
import _ from 'lodash';

const JOKL_COUPONS_DEFAULT_STATE = {};

const JoklCouponsReducer = (state = JOKL_COUPONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_JOKL_COUPONS:
            return payload;

        case SET_JOKL_COUPON_PROCESSED:
            return { ...state, items: _.map(state.items, item => {
                if (item.code === payload.code) {
                    item = { ...item, status: 'processed', data: { ...item.data, order_number: payload.number } };
                }

                return item;
            }) };

        case CLEAN_JOKL_COUPONS:
        case DELETE_JOKL_COUPON:
            return JOKL_COUPONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default JoklCouponsReducer;
